const scheme = {
  type: 'object',
  properties: {
    firstName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'First Name is required',
    },
    lastName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Last Name is required',
    },
    phone: { type: 'string', minLength: 1, errorMessage: 'Phone is required' },
    email: { type: 'string', minLength: 1, errorMessage: 'E-mail is required' },
    dob: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Date of Birth is required',
    },
    nationalityId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Nationality is required',
    },
    deliveryChannelId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Delivery Channel is required',
    },
  },
  required: [
    'firstName',
    'lastName',
    'phone',
    'dob',
    'email',
    'nationalityId',
    'deliveryChannelId',
  ],
};

export default scheme;
